module.exports = __webpack_public_path__ + "static/media/AZ.e9dc94be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/AZ.svg
// module id = 2105
// module chunks = 7